<template>
  <VAlert
    :color="props.color"
    :type="props.type"
    class="easy-alert"
  >
    <template
      v-if="slots['prepend']"
      #prepend
    >
      <slot name="prepend" />
    </template>

    <template #title>
      <span
        v-if="props.title"
        data-cy="title__easy-alert"
      >
        {{ props.title }}
      </span>
      <slot
        v-else-if="slots['title']"
        name="title"
      />
    </template>

    <template #text>
      <span
        v-if="props.text"
        data-cy="text__easy-alert"
      >
        {{ props.text }}
      </span>
      <slot
        v-else-if="slots['text']"
        name="text"
      />
    </template>

    <template
      v-if="props.closeable"
      #close
    >
      <DSIcon
        class="text-gray-300 hover:text-text cursor-pointer absolute right-2 top-2"
        icon="e-remove"
        :size="DS_ICON_SIZES.Small"
        data-cy="close-icon__easy-alert"
        @click="emit('close')"
      />
    </template>
  </VAlert>
</template>

<script setup lang="ts">
import { DSIcon } from "@/src/design_system";
import { DS_ICON_SIZES } from "@/src/design_system/primitives/icon/types";
import { EasyAlerts } from "../types";
import { useSlots } from "vue";
import { VueSlots } from "@/src/shared/types/slot";

interface Props {
  text?: string;
  title?: string;
  type?: EasyAlerts;
  icon?: string;
  closeable?: boolean;
  color?: string;
}

const props = withDefaults(defineProps<Props>(), {
  type: EasyAlerts.Error,
  title: undefined,
  text: undefined,
  icon: undefined,
  closeable: false,
  color: undefined,
});

const slots = useSlots() as VueSlots<["title", "prepend", "text"]>;

interface Emits {
  (e: "close"): void;
}

const emit = defineEmits<Emits>();
</script>
